import custom_axios from "../axios";

// GET /label-codes
export const get_label_codes = async (printer_brand) => {
  try {
    if (printer_brand) {
      const response = await custom_axios.get(
        `/print-barcode/label-codes?printer_brand=${printer_brand}`
      );
      return response.data;
    } else {
      const response = await custom_axios.get(`/print-barcode/label-codes`);
      return response.data;
    }
  } catch (error) {
    console.error("Failed to fetch label codes:", error);
    throw error;
  }
};

export const get_printer_brands = async (url) => {
  try {
    const data = { url: url };
    const response = await custom_axios.get(
      `/print-barcode/printer-brands`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch printer brands:", error);
    throw error;
  }
};

export const get_custom_barcode_template_by_id = async (id) => {
  try {
    const response = await custom_axios.get(
      `/print-barcode/custom-barcode-template`,
      {
        params: { id },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch custom barcode template by id:", error);
    throw error;
  }
};

export const get_all_barcode_templates = async () => {
  try {
    const response = await custom_axios.get(
      `/print-barcode/custom-barcode-template`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch all barcode templates:", error);
    throw error;
  }
};

export const create_custom_barcode_template = async (templateData) => {
  try {
    const response = await custom_axios.post(
      `/print-barcode/custom-barcode-template`,
      templateData
    );
    return response;
  } catch (error) {
    console.error("Failed to create custom barcode template:", error);
    throw error;
  }
};
export const update_custom_barcode_template = async (templateId,templateData) => {
  try {
    const response = await custom_axios.put(
      `/print-barcode/custom-barcode-template/${templateId}`,
      templateData
    );
    return response;
  } catch (error) {
    console.error("Failed to create custom barcode template:", error);
    throw error;
  }
};

export const get_label_components = async () => {
  try {
    const response = await custom_axios.get(`/print-barcode/label-components`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch printer brands:", error);
    throw error;
  }
};

export const get_label_units = async () => {
  try {
    const response = await custom_axios.get(`/print-barcode/label-units`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch printer brands:", error);
    throw error;
  }
};

export const get_all_barcode_symbols = async () => {
  try {
    const response = await custom_axios.get(
      `/print-barcode/barcode-symbol-components`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch all barcode symbol:", error);
    throw error;
  }
};

export const get_one_label_code = async (id) => {
  try {
    const response = await custom_axios.get(`/print-barcode/label-code/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch label code:", error);
    throw error;
  }
};

export const get_all_printer_label_code = async (printer_brand) => {
  try {
    const response = await custom_axios.get(
      `/print-barcode/printer-label-codes/${printer_brand}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch label cods:", error);
    throw error;
  }
};
